import {AppDispatch} from "../redux/store";
import {AppState, clearFormState, updateCurrentStateWithStandardFormProps} from "../redux/AppStateSlice";
import {ErrorMessages, PayloadObject} from "../redux";
import {getLogger} from "../logConfig";
import {local} from "../internationalization/Localization";

const NEW_PASSWORD_SERVER_VALIDATION_ERROR = local.get("errorMessages.NEW_PASSWORD_SERVER_VALIDATION_ERROR")
const PASSWORD_RECENTLY_USED = local.get("errorMessages.PASSWORD_RECENTLY_USED")
const CONTAINS_NAME_ID = local.get("errorMessages.CONTAINS_NAME_ID")
export const DEFAULT_CAM_ERROR_MESSAGE = local.get("errorMessages.DEFAULT_CAM_ERROR_MESSAGE")
export const PASSWORD_LOCKED_MSG = "Your account is locked. Please reset your password to continue."

export const errorMessages: ErrorMessages = {
  CHALLENGE_QUESTIONS_LOCKED: DEFAULT_CAM_ERROR_MESSAGE,
  PASSWORD_TOTAL_LENGTH_OUT_OF_RANGE: NEW_PASSWORD_SERVER_VALIDATION_ERROR,
  PASSWORD_DUP_SUBSTRING: NEW_PASSWORD_SERVER_VALIDATION_ERROR,
  PASSWORD_RECENTLY_USED: PASSWORD_RECENTLY_USED,
  INVALID_CREDENTIALS: "wrong_credential",
  INVALID_CREDENTIALS_CHALLENGE_QA: local.get("errorMessages.INVALID_CREDENTIALS_CHALLENGE_QA"),
  PASSWORD_NOT_ALLOWED_CHARS: NEW_PASSWORD_SERVER_VALIDATION_ERROR,
  PASSWORD_NUM_OF_RULES_MATCHED_BELOW_LIMIT: NEW_PASSWORD_SERVER_VALIDATION_ERROR,
   PASSWORD_LOCKED: PASSWORD_LOCKED_MSG,
  // ACCOUNT_INACTIVE: DEFAULT_CAM_ERROR_MESSAGE,
  // ACCOUNT_DISABLED_AND_INVALID: DEFAULT_CAM_ERROR_MESSAGE,
  PWD_CORRECT_BUT_EXPIRED: local.get("errorMessages.PWD_CORRECT_BUT_EXPIRED"),
  PASSWORD_CONTAINS_NAME: CONTAINS_NAME_ID
}

const logger = getLogger("CustomFormSession");

export class CustomFormSession implements com.ts.mobile.sdk.UIFormSession {
  formId: string;
  payload: PayloadObject;
  clientContext: object | null;
  actionContext: com.ts.mobile.sdk.PolicyAction | null;
  errorMessage: string;
  dispatch: AppDispatch;
  eCode: string;

  constructor(formId: string, payload: object, dispatch: AppDispatch) {
    this.formId = formId;
    this.payload = payload as any;
    this.dispatch = dispatch;
    this.clientContext = null;
    this.actionContext = null;
    this.errorMessage = "";
    this.eCode = "";
  }

  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    this.clientContext = clientContext;
    this.actionContext = actionContext;

    if ((this.payload.password_reset_status && this.payload.password_reset_status.errors.length > 0) ||
      (this.payload.challenge_qa_reset_status && this.payload.challenge_qa_reset_status.errors.length > 0)) {
      let error = this.payload.password_reset_status ? this.payload.password_reset_status.errors[0] : this.payload.challenge_qa_reset_status.errors[0];
      this.errorMessage = errorMessages[`${error.code}`] || error.message;
    }
    logger.debug("Started Custom Form Session");
  }

  endSession(): void {
    logger.debug("Ending Custom Form Session");
    this.dispatch(clearFormState);
  }

  onContinue(payload: object | null): void {
    this.payload = payload as any;
  }

  onError(payload: object | null): void {
    let msg = payload && (payload as any).msg;
    this.eCode = payload && (payload as any).errors?.[0]?.code;
    this.errorMessage = errorMessages[`${this.eCode}`] || msg;
    if(this.formId === "validate_challenge_qa" && this.eCode === "INVALID_CREDENTIALS"){
      this.errorMessage = errorMessages.INVALID_CREDENTIALS_CHALLENGE_QA; // Authe sends same ErrorCode [INVALID_CREDENTIALS] for bad password/bad challenge QA answer
    }
  }

  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    let currentAppState: AppState | null =
      this.formId === "remember_device" ? AppState.REMEMBER_DEVICE :
      this.formId === "collect_password" ? AppState.COLLECT_PASSWORD :
      this.formId === "set_challenge_questions_and_answers" ? AppState.SET_CHALLENGE_QA :
      this.formId === "collect_current_and_new_password" ? AppState.COLLECT_CURRENT_AND_NEW_PASSWORD :
      this.formId === "collect_username" ? AppState.COLLECT_USERNAME :
      this.formId === "welcome_user" || this.formId === "reg_success" ? AppState.REGISTRATION_INFORMATION :
      this.formId === "validate_challenge_qa" ? AppState.VALIDATE_CHALLENGE_QA :
      this.formId === "registration_link_expired" ? AppState.REGISTRATION_LINK_EXPIRED :
      null;

    if (currentAppState === null) {
      throw new Error("No Form implemented for formId:" + this.formId);
    } else {
      return new Promise<com.ts.mobile.sdk.FormInput>((resolve: any) => {
        this.dispatch(updateCurrentStateWithStandardFormProps({
            state: currentAppState as AppState,
            resolve,
            actionContext: this.actionContext,
            payload: this.payload,
            errorMessage: this.eCode === "CHALLENGE_QUESTIONS_LOCKED" ? this.eCode : this.errorMessage,
            clientContext: this.clientContext as any,
            formId: this.formId as any,
          }));
      });
    }
  }
}
